"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTimeRangeBymoment = getTimeRangeBymoment;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _moment = _interopRequireDefault(require("moment"));
var _constants = require("./constants");
var dateTimeStamp = {
  ONE_WEEK_AGO: (0, _moment["default"])().add(-7, 'd').valueOf(),
  ONE_MONTH_AGO: (0, _moment["default"])().add(-1, 'months').valueOf(),
  SIX_MONTHS_AGO: (0, _moment["default"])().add(-6, 'months').valueOf(),
  ONE_YEAR_AGO: (0, _moment["default"])().add(-1, 'y').valueOf()
};
function getTimeRangeBymoment() {
  return (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _constants.TIME_RANGE_TYPE.NOW_TIME, {
    startTimeStamp: (0, _moment["default"])().valueOf(),
    endTimeStamp: (0, _moment["default"])().valueOf()
  }), _constants.TIME_RANGE_TYPE.THIS_WEEK, {
    startTimeStamp: dateTimeStamp.ONE_WEEK_AGO,
    endTimeStamp: (0, _moment["default"])().valueOf()
  }), _constants.TIME_RANGE_TYPE.PREVIOUS_WEEK, {
    startTimeStamp: 0,
    endTimeStamp: dateTimeStamp.ONE_WEEK_AGO
  }), _constants.TIME_RANGE_TYPE.PREVIOUS_MONTH, {
    startTimeStamp: 0,
    endTimeStamp: dateTimeStamp.ONE_MONTH_AGO
  }), _constants.TIME_RANGE_TYPE.PREVIOUS_HALF_YEAR, {
    startTimeStamp: 0,
    endTimeStamp: dateTimeStamp.SIX_MONTHS_AGO
  }), _constants.TIME_RANGE_TYPE.PREVIOUS_YEAR, {
    startTimeStamp: 0,
    endTimeStamp: dateTimeStamp.ONE_YEAR_AGO
  });
}
//# sourceMappingURL=time.js.map